export default __webpack_public_path__ + "static/media/chevron-right.1b594e60.svg";